/** @jsx jsx */
import { jsx } from '@emotion/core';
import { withNamespaces } from 'react-i18next';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import PropTypes from 'prop-types';
import defaultsDeep from 'lodash/defaultsDeep';
import compose from 'lodash/fp/compose';
import Spacer from '../../../../ui/Spacer';
import DotComponent from '../../../../ui/DotComponent';
import createButtonCss from '../../../../ui/Button/Button';
import { Container, Column, Row } from '../../../../../styles/Grid';
import { SafePureComponent } from '../../../../../utils/SafePureComponent';
import { withConsumer } from '../../../../../contexts';
import { SolutionBuilderConsumer } from '../../../../../contexts/SolutionBuilderContext';
import * as styles from './index.styles';

const defaultData = {
  IntroHeadline: { value: '' },
  IntroStartCTA: { value: '' },
  IntroBodyText: { value: '' },
};

export class Intro extends SafePureComponent {
  safeRender() {
    const { manager } = this.props;
    const fields = defaultsDeep(this.props.fields, defaultData);
    const { IntroHeadline, IntroBodyText, IntroStartCTA } = fields;
    return (
      <Spacer>
        <Container css={styles.introContentWrapper}>
          <Row css={styles.introContentRow}>
            <Column
              cols={{ sm: 6, md: 6, lg: 8, xl: 6 }}
              offsets={{ sm: 0, md: 1, lg: 2, xl: 3 }}
            >
              <h2 css={styles.headline}>
                <Text field={IntroHeadline} />
                <DotComponent />
              </h2>
              <p css={styles.bodyText}>
                <Text field={IntroBodyText} />
              </p>
            </Column>
            <Column
              cols={{ sm: 4, md: 4, lg: 4, xl: 2 }}
              offsets={{ sm: 1, md: 2, lg: 4, xl: 5 }}
            >
              <button onClick={manager.goNext} css={[createButtonCss()]}>
                {IntroStartCTA.value}
              </button>
            </Column>
          </Row>
        </Container>
      </Spacer>
    );
  }
}

Intro.displayName = 'SolutionBuilder/Templates/Intro';

Intro.defaultProps = {
  fields: defaultData,
};

Intro.propTypes = {
  fields: PropTypes.shape({
    Headline: PropTypes.shape({ value: PropTypes.string }),
    BodyText: PropTypes.shape({ value: PropTypes.string }),
    StartCta: PropTypes.shape({ value: PropTypes.string }),
  }),
};

export default compose(
  withNamespaces(),
  withConsumer(SolutionBuilderConsumer, 'manager'),
)(Intro);
